import React, { useState, useRef, useEffect } from 'react';
import { Box, Skeleton } from '@mui/material';

const LazyLoadWrapper = ({ 
  children, 
  height = 200, 
  threshold = 0.1,
  rootMargin = '50px',
  fallback = null 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasLoaded) {
          setIsVisible(true);
          setHasLoaded(true);
          // Disconnect observer after loading
          observer.disconnect();
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [threshold, rootMargin, hasLoaded]);

  if (isVisible) {
    return <>{children}</>;
  }

  return (
    <Box ref={elementRef} sx={{ height: height || 'auto' }}>
      {fallback || (
        <Skeleton
          variant="rectangular"
          height={height}
          animation="wave"
          sx={{
            borderRadius: 2,
            bgcolor: 'grey.200',
            '&::after': {
              background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
            },
          }}
        />
      )}
    </Box>
  );
};

export default LazyLoadWrapper;
